// OMS Constants
export const PRICE_PERCENTAGE_DIVISOR = 100
export const DEFAULT_PAR_VALUE_PRICING = 100

export const SETTLEMENT_TYPES = {
  T_PLUS_1: 't_plus_1',
  T_PLUS_2: 't_plus_2',
  T_PLUS_3: 't_plus_3',
  NEGOTIATED: 'negotiated'
}

export const SETTLEMENT_DISPLAY = {
  [SETTLEMENT_TYPES.T_PLUS_1]: 'T+1',
  [SETTLEMENT_TYPES.T_PLUS_2]: 'T+2',
  [SETTLEMENT_TYPES.T_PLUS_3]: 'T+3',
  [SETTLEMENT_TYPES.NEGOTIATED]: 'Negotiated'
}

export const TRANSACTION_TYPES = {
  BUY: 'buy',
  SELL: 'sell'
}

export const COMMISSION_TYPES = {
  CAPITAL_PRICE_PREMIUM: 'capital-price-premium',
  MARGIN_SPREAD: 'margin-spread'
}

// MAX_PAGE_COUNT is the maximum number of pages allowed for a security document
// Should match the value in Document::MAX_PAGE_COUNT
export const MAX_PAGE_COUNT = 10

// Document types - should match Document model constants
export const TERM_SHEET = 'term_sheet'
